import {Injectable} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {routingMetadata} from '../signal/common/routing-matadata.signal';
import {RoutingMetadata} from '../model/routing-metadata.model';

@Injectable({providedIn: 'root'})
export class RoutingMetadataResolver {

  private readonly baseFaviconUrl: string = 'assets/favicons/favicon.ico';

  constructor(private readonly router: Router, private readonly route: ActivatedRoute) {
  }

  public init(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let deepest = this.route;
        while (deepest.firstChild) deepest = deepest.firstChild;

        const metadata: RoutingMetadata = {
          theme: deepest.snapshot.data?.['theme'] ?? '',
          logotypeUrl: deepest.snapshot.data?.['logotypeUrl'] ?? this.baseFaviconUrl,
          faviconUrl: deepest.snapshot.data?.['faviconUrl'] ?? '',
          label: deepest.snapshot.data?.['label'] ?? '',
          contact: deepest.snapshot.data?.['contact'] ?? undefined,
        }

        routingMetadata.set(metadata);
      });
  }
}
